import React from 'react';
import { connect } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { Page, Footer, LayoutComposer } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import css from './SubscriptionPlanPage.module.css';

const SubscriptionPlanPageComponent = props => {
  const { scrollingDisabled } = props;

  const layoutAreas = `
    topbar
    main
    footer
  `;

  return (
    <Page
      title="LuLocal Rate Plan"
      description="Flat Monthly Fee. No Commission. No Listing Fees."
      scrollingDisabled={scrollingDisabled}
    >
      <LayoutComposer areas={layoutAreas}>
        {props => {
          const { Topbar, Main, Footer: FooterSection } = props;
          return (
            <>
              <Topbar as="header">
                <TopbarContainer />
              </Topbar>
              <Main as="main">
                <div className={css.container}>
                  <div className={css.ratePlanCard}>
                    <div className={css.cardHeader}>
                      
                      <h1 className={css.headerTitle}>Lulocal Rate Plan $29 /mo</h1>
                      <div className={css.priceSection}>
                        <div className={css.priceSubLabel}>
                          Flat Monthly Fee. No Commission. No Listing Fees.
                        </div>
                      </div>
                    </div>

                    <div className={css.featuresBanner}>FEATURES:</div>

                    <ul className={css.featuresList}>
                      <li className={css.featureItem}>
                        <strong>First Month Free!</strong>
                      </li>
                      <li className={css.featureItem}>
                        Highlight up to <strong>9 products or services at one time</strong>
                      </li>
                      <li className={css.featureItem}>
                        <strong>Coupon tool:</strong> Free to Create and Promote coupons on LuLocal
                      </li>
                      <li className={css.featureItem}>
                        <strong>Dedicated business page</strong> on LuLocal.com. Includes merchant photos, description, announcements, coupons and highlighted items
                      </li>
                      <li className={css.featureItem}>
                        <strong>Dedicated shareable link</strong> to your business page. Create promotions in LuLocal and promote the link everywhere you market today (your website, social, etc.)
                      </li>
                      <li className={css.featureItem}>
                        <strong>Unlimited Sales. Month to Month Agreement,*</strong> no cancellation fees
                      </li>
                      <li className={css.featureItem}>
                        <strong>Standard Credit Card Merchant fees apply.</strong> 2.9% + .30 per transaction. Credit card transactions managed by Stripe.
                      </li>
                    </ul>
                  </div>

                  <div className={css.additionalTerms}>
                    <h3 className={css.termsTitle}>Additional Terms:</h3>
                    <ul className={css.termsList}>
                      <li className={css.termsItem}>Month to month agreement with no cancellation fees</li>
                      <li className={css.termsItem}>First month free, then Billed every 30 days thereafter</li>
                      <li className={css.termsItem}>If account is cancelled, your account will remain active until the end of your 30-day period</li>
                      <li className={css.termsItem}>We are unable to provide credits for partial month cancellations</li>
                    </ul>
                  </div>

                  <div className={css.helpSection}>
                    <div className={css.helpText}>
                      If you want to learn more or have questions about setting up your account, simply email us. Don't be shy - we love to help!
                    </div>
                    <a href="mailto:info@lulocal.com" className={css.helpButton}>
                      We're Here to Help
                    </a>
                  </div>
                </div>
              </Main>
              <FooterSection>
                <Footer />
              </FooterSection>
            </>
          );
        }}
      </LayoutComposer>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

export default connect(mapStateToProps)(SubscriptionPlanPageComponent);
